import { module } from "modujs";

import NotLocomotiveScroll from "../classes/NotLocomotiveScroll";
import ScrollCall from "../classes/NotLocomotiveScroll/helpers/ScrollCall";
import ScrollTo from "../classes/NotLocomotiveScroll/helpers/ScrollTo";

import { lazyLoadImage } from "../utils/image";
import { html } from "../utils/environment";

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onCall = this.onCall.bind(this);
        this.onScroll = this.onScroll.bind(this);
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        setTimeout(() => {
            this.scrollInstance = new NotLocomotiveScroll(this.el, {
                scrollCallback: this.onScroll,
                hasSmoothScroll: false
            });

            this.scrollInstance.start();

            ScrollCall.on("call", this.onCall);
        }, 100);
    }

    destroy() {
        this.scrollInstance.destroy();
    }

    ///////////////
    // Callbacks
    ///////////////
    onCall(func, way, obj, id) {
        // Using modularJS
        this.call(func[0], { way, obj }, func[1], func[2]);
    }

    onScroll(scrollObj) {
        if (scrollObj.direction == 1) {
            html.classList.add("is-scrolling-down");
        } else {
            html.classList.remove("is-scrolling-down");
        }

        if (scrollObj.current > 80) {
            html.classList.add("has-scrolled");
        } else {
            html.classList.remove("has-scrolled");
        }
    }

    ///////////////
    // Methods
    ///////////////
    update() {
        this.scrollInstance && this.scrollInstance._onResize()
    }

    lazyLoad(args) {
        lazyLoadImage(args.obj.target, null, () => {
            this.setData("lazy", "", args.obj.target);
        });
    }

    scrollTo(args) {
        ScrollTo.goTo(args[0], args[1]);
    }

    destroy() {
        super.destroy();

        html.classList.remove("has-scrolled");
    }
}
